import React from 'react';

export const NotFoundPage: React.FC = () => (
  <h1 className="title">Page not found</h1>
);
